export const ConvertBase64ToPng = async function (base64, fileName, shouldCompress) {
  if (shouldCompress === void 0) {
    shouldCompress = true;
  }
  if (typeof window === "undefined" || !base64 || !fileName) {
    return;
  }
  return await new Promise(resolve => {
    let rawImage = new Image();
    const loader = () => {
      rawImage.removeEventListener("load", loader);
      resolve(rawImage);
    };
    rawImage.addEventListener("load", loader);
    rawImage.src = base64;
  }).then(rawImage => {
    return new Promise(resolve => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (shouldCompress) {
        const curWidth = 1200;
        const curHeight = 630;
        const maxSize = rawImage.width > rawImage.height ? Math.abs(curWidth - rawImage.width) : Math.abs(curHeight - rawImage.height);
        rawImage.height = rawImage.height + maxSize;
        rawImage.width = rawImage.width + maxSize;
        canvas.width = curWidth;
        canvas.height = curHeight;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        const dy = parseInt((canvas.height - rawImage.height) / 2, 10);
        const dx = parseInt((canvas.width - rawImage.width) / 2, 10);
        ctx.drawImage(rawImage, dx, dy, rawImage.width, rawImage.height);
      } else {
        canvas.width = rawImage.width;
        canvas.height = rawImage.height;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(rawImage, 0, 0, rawImage.width, rawImage.height);
      }
      canvas.toBlob(blob => {
        resolve(blob);
      }, "image/png");
    }).then(blob => {
      return {
        blob,
        fileName: `${fileName.substring(0, fileName.lastIndexOf("."))}.png`
      };
    });
  });
};